<ion-card>
  <ion-card-header>
    <ion-card-title>Frissítés</ion-card-title>
    <ion-card-subtitle>Mi fut most, van-e újabb, és rendben van-e az adatbázis</ion-card-subtitle>
  </ion-card-header>

  <ion-card-content>
    <div class="fr-allapot" *ngIf="toltodik"><ion-spinner name="dots"></ion-spinner><span>Betöltés…</span></div>
    <div class="fr-allapot hiba" *ngIf="!toltodik && hiba">
      <ion-icon name="alert-circle-outline"></ion-icon><span>{{ hiba }}</span>
    </div>

    <ng-container *ngIf="!toltodik && allapot">
      <!-- 1. Verzió -->
      <div class="fr-verzio">
        <div class="fr-kartya">
          <span>Most fut</span>
          <b>{{ allapot.jelenlegi?.verzio || 'ismeretlen' }}</b>
          <small *ngIf="allapot.jelenlegi?.build">build: {{ allapot.jelenlegi.build }}</small>
          <small *ngIf="feluletVerzio" [class.fr-elter]="feluletElavult">felület: {{ feluletVerzio }}</small>
        </div>
        <div class="fr-nyil"><ion-icon name="arrow-forward-outline"></ion-icon></div>
        <div class="fr-kartya" [class.uj]="allapot.verzio?.van_ujitas">
          <span>Elérhető</span>
          <b>{{ allapot.verzio?.legujabb || '—' }}</b>
          <small *ngIf="allapot.verzio?.ellenorizve">ellenőrizve: {{ allapot.verzio.ellenorizve | date:'HH:mm' }}</small>
        </div>
        <div class="fr-verzio-gombok">
          <ion-button size="small" fill="outline" (click)="betolt(true)">
            <ion-icon slot="start" name="refresh-outline"></ion-icon>Ellenőrzés most
          </ion-button>
          <!-- CÉLVERZIÓ. Nem csak a legújabbra lehet frissíteni: vissza egy korábbira,
               vagy előre egy konkrétra akkor is, ha a FUTÓ verzió ismeretlen. -->
          <ion-select label="Cél verzió" labelPlacement="stacked" interface="popover"
                      *ngIf="valaszthatoVerziok.length" [(ngModel)]="celVerzio" class="fr-cel">
            <ion-select-option *ngFor="let v of valaszthatoVerziok" [value]="v">
              {{ v }}{{ v === allapot.verzio?.legujabb ? ' (legújabb)' : '' }}
            </ion-select-option>
          </ion-select>
          <ion-button size="small" color="primary" [disabled]="indit || !indithato"
                      (click)="frissitesIndit()">
            <ion-icon slot="start" name="cloud-download-outline"></ion-icon>
            {{ indit ? 'Indítás…' : 'Frissítés indítása' }}
          </ion-button>
        </div>
      </div>

      <!--  FELÜLET vs KISZOLGÁLÓ. Két külön dolog, és eltérhetnek: az alkalmazás
            egyoldalas, tehát egy nyitva maradt fül a frissítés után is a RÉGI kódot
            futtatja. Ilyenkor a verziószám stimmel, az új menüpont mégsem látszik. -->
      <ion-note color="warning" class="fr-megj" *ngIf="feluletElavult">
        A böngésződben <b>régebbi felület</b> fut ({{ feluletVerzio }}), mint a kiszolgáló
        ({{ allapot.jelenlegi?.verzio }}). Ez frissítés után normális, ha a fület nyitva hagytad:
        az oldal magától nem tölti újra magát. Az új képernyők és menüpontok addig <b>nem látszanak</b>.
        <ion-button size="small" fill="outline" (click)="feluletetUjratolt()">Felület újratöltése</ion-button>
      </ion-note>

      <ion-note color="warning" class="fr-megj" *ngIf="allapot.verzio?.verzio_ismeretlen">
        A futó verzió <b>ismeretlen</b> — a képfájl címkéjét a telepítésnek kell átadnia
        (<code>APP_VERZIO</code>). Amíg hiányzik, nem tudjuk mihez hasonlítani az elérhetőt,
        ezért <b>nem állítunk újdonságot</b> (a hamis „van frissítés" zajjá tenné a jelzést),
        és az adminisztrátorok <b>felső sávja sem jelenik meg</b>.
        <b>Frissíteni ettől még lehet:</b> válaszd ki a cél verziót, és indítsd el —
        csak azt nem tudjuk megmondani, hogy az újabb-e a mostaninál.
      </ion-note>
      <ion-note color="warning" class="fr-megj" *ngIf="allapot.verzio?.hiba">
        A registry nem válaszolt: {{ allapot.verzio.hiba }}. Privát projektnél felhasználó és
        jelszó is kell — enélkül úgy látszana, mintha nem volna új verzió.
      </ion-note>
      <ion-note color="warning" class="fr-megj" *ngIf="!allapot.beallitva">
        A <b>frissítő szolgáltatás</b> nincs beállítva, ezért a frissítés a felületről nem
        indítható. (Ez egyszeri telepítési lépés — lásd a beállításokat.)
      </ion-note>

      <!-- 2. Adatbázis -->
      <h3 class="fr-cim">Adatbázis-migrációk</h3>
      <div class="fr-migracio" [class.baj]="!allapot.migracio?.rendben">
        <ion-icon [name]="allapot.migracio?.rendben ? 'checkmark-circle-outline' : 'alert-circle-outline'"></ion-icon>
        <div>
          <b *ngIf="allapot.migracio?.rendben">Rendben — {{ allapot.migracio.lefutott }}/{{ allapot.migracio.osszes }} migráció lefutott.</b>
          <b *ngIf="!allapot.migracio?.rendben">Figyelmet igényel.</b>
          <div *ngIf="allapot.migracio?.hianyzo?.length">
            Hiányzik: <code *ngFor="let f of allapot.migracio.hianyzo">{{ f }}</code>
          </div>
          <div *ngIf="allapot.migracio?.hibas?.length">
            Hibás: <span *ngFor="let h of allapot.migracio.hibas"><code>{{ h.fajl }}</code> — {{ h.hiba }}</span>
          </div>
          <div *ngIf="allapot.migracio?.megvaltozott?.length" class="fr-megvaltozott">
            <b>Utólag átírt fájl:</b> <code *ngFor="let f of allapot.migracio.megvaltozott">{{ f }}</code>.
            Ezeket <b>nem</b> futtatjuk újra — az adatot tönkretehetné. A javítás módja
            <b>új migráció</b>, nem a régi átírása.
          </div>
        </div>
        <ion-button size="small" fill="outline" *ngIf="allapot.migracio?.hianyzo?.length"
                    (click)="migracioFuttat()">Hiányzók futtatása</ion-button>
      </div>

      <!-- 3. A frissítő szolgáltatás -->
      <!--  MIÉRT VAN EZ ITT?
            A frissítő végzi a konténerek cseréjét, ezért magát NEM cserélheti közben:
            a képfájlját rögzített címkével hivatkozzuk, és így csöndben ottragad egy
            régi változaton. Élesben ez odáig jutott, hogy minden frissítés
            „megszakadt"-tal zárult egy rég kijavított hiba miatt – csak a javítás nem
            ért el hozzá, és sehol nem látszott, melyik változat fut. Itt látszik. -->
      <ng-container *ngIf="frissito?.beallitva">
        <h3 class="fr-cim">Frissítő szolgáltatás</h3>

        <div class="fr-frissito" [class.baj]="!frissito.elerheto || frissito.regi || frissito.onellenorzes?.baj?.length">
          <ion-icon [name]="!frissito.elerheto ? 'cloud-offline-outline'
                            : (frissito.regi || frissito.onellenorzes?.baj?.length ? 'alert-circle-outline' : 'checkmark-circle-outline')"></ion-icon>
          <div>
            <b *ngIf="!frissito.elerheto">Nem válaszol.</b>
            <div *ngIf="!frissito.elerheto">
              {{ frissito.hiba }} — amíg nem válaszol, a felületről indított frissítés nem
              jut el hozzá. A konténere fut-e (<code>frissito</code>), és jó címen keressük-e?
            </div>

            <ng-container *ngIf="frissito.elerheto">
              <b>
                Verzió: {{ frissito.verzio || 'ismeretlen' }}
                <span *ngIf="frissito.mod"> · {{ frissito.mod === 'portainer' ? 'Portainer-mód' : 'compose-fájl mód' }}</span>
              </b>
              <div *ngIf="frissito.szolgaltatasok?.length">
                Cserélt szolgáltatások: <code *ngFor="let sz of frissito.szolgaltatasok">{{ sz }}</code>
              </div>

              <div *ngIf="frissito.regi" class="fr-frissito-regi">
                <b>A frissítőből hiányzik egy javítás: {{ frissito.verzio }} verzión áll, a legfrissebb frissítő-kód a {{ frissito.rendszer }}.</b>
                Ez nem magától javul: ő cseréli a konténereket, ezért <b>saját magát nem
                cseréli le</b> — a képfájlja szándékosan rögzített címkén van. Emeld a
                <code>frissito</code> képfájl címkéjét a stackben (Portainernél a stack
                szerkesztőjében), és telepítsd újra egyszer. Amíg ez elmarad, a már
                kijavított frissítési hibák továbbra is jelentkeznek.
              </div>

              <div *ngIf="frissito.verzio === 'ismeretlen'" class="fr-frissito-regi">
                A frissítő nem mondja meg a verzióját — ez a <b>2.3.62 előtti</b> képfájlokra
                igaz. Érdemes a címkéjét a mostani verzióra emelni.
              </div>

              <div *ngIf="frissito.onellenorzes?.baj?.length" class="fr-frissito-baj">
                <b>Az önellenőrzés ezt találta</b>
                <span *ngIf="frissito.onellenorzes?.ekkor" class="fr-ellenorizve">
                  ({{ frissito.onellenorzes.ekkor | date:'yyyy.MM.dd. HH:mm:ss' }} — az „Újra" gomb
                  most futtatja le ismét)</span>:
                <pre *ngFor="let b of frissito.onellenorzes.baj">{{ b }}</pre>
              </div>
              <div *ngIf="frissito.elerheto && !frissito.regi && !frissito.onellenorzes?.baj?.length">
                Az önellenőrzés rendben — a Docker és a stack elérhető.
              </div>
            </ng-container>
          </div>
          <ion-button size="small" fill="outline" (click)="frissitoUjra()">
            <ion-icon slot="start" name="refresh-outline"></ion-icon>Újra
          </ion-button>
        </div>
      </ng-container>

      <!-- 3. Folyamatban -->
      <ng-container *ngIf="lepesek.length">
        <h3 class="fr-cim">
          Frissítés folyamata
          <ion-chip [color]="allapotSzin(futas?.allapot)">{{ futas?.allapot }}</ion-chip>
          <!-- Megszakítás: ha a lezáró jelentés elveszett, ne kelljen fél órát várni
               az elakadás-őrre. A megkezdett lépést nem vágjuk félbe. -->
          <ion-button size="small" fill="outline" color="danger"
                      *ngIf="futas?.allapot === 'fut'"
                      [disabled]="megszakitFut" (click)="frissitestMegszakit()">
            Megszakítás
          </ion-button>
        </h3>
        <div class="fr-lepesek">
          <div *ngFor="let l of lepesek" [class]="'fr-lepes ' + l.allapot">
            <ion-icon [name]="l.allapot === 'ok' ? 'checkmark-circle' : (l.allapot === 'hiba' ? 'close-circle' : 'ellipse-outline')"></ion-icon>
            <div>
              <b>{{ l.lepes }}</b>
              <span class="fr-ido">{{ l.ido | date:'HH:mm:ss' }}</span>
              <pre *ngIf="l.uzenet">{{ l.uzenet }}</pre>
            </div>
          </div>
        </div>
      </ng-container>

      <!-- 4. Karbantartás -->
      <h3 class="fr-cim">Karbantartás</h3>
      <div class="fr-karbantartas" [class.be]="allapot.karbantartas?.be">
        <span *ngIf="!allapot.karbantartas?.be">Nincs karbantartás — mindenki dolgozhat.</span>
        <span *ngIf="allapot.karbantartas?.be">
          <b>Karbantartás alatt.</b> A sima felhasználók a „frissítés folyamatban" oldalt látják;
          az adminisztrátorok tovább dolgozhatnak.
        </span>
        <ion-button size="small" fill="outline" *ngIf="!allapot.karbantartas?.be"
                    (click)="karbantartasValt(true)">Bekapcsolás</ion-button>
        <ion-button size="small" color="success" *ngIf="allapot.karbantartas?.be"
                    (click)="karbantartasValt(false)">Kikapcsolás</ion-button>
      </div>
      <ion-note color="medium" class="fr-megj">
        Kézi kapcsoló — vészhelyzeti kiút, ha egy frissítés félbemaradt. Frissítéskor a
        rendszer magától be- és kikapcsolja.
      </ion-note>

      <!-- 5. Korábbi futások -->
      <ng-container *ngIf="allapot.futasok?.length">
        <h3 class="fr-cim">Korábbi frissítések</h3>
        <table class="fr-tabla">
          <thead><tr><th>Indult</th><th>Honnan → hova</th><th>Állapot</th><th>Indította</th></tr></thead>
          <tbody>
            <tr *ngFor="let f of allapot.futasok">
              <td>{{ f.indult | date:'yyyy-MM-dd HH:mm' }}</td>
              <td>{{ f.honnan || '—' }} → {{ f.hova || '—' }}</td>
              <td><ion-chip [color]="allapotSzin(f.allapot)">{{ f.allapot }}</ion-chip></td>
              <td>{{ f.inditotta || '—' }}</td>
            </tr>
          </tbody>
        </table>
      </ng-container>

      <!-- 6. Beállítások -->
      <h3 class="fr-cim">
        Beállítások
        <ion-button size="small" fill="clear" (click)="beallitasBetoltese()">
          {{ beallitasNyitva ? 'Bezár' : 'Megnyit' }}
        </ion-button>
      </h3>
      <div class="fr-beallitas" *ngIf="beallitasNyitva">
        <ion-item lines="none">
          <ion-toggle [(ngModel)]="beallitas.ellenorzes_be">Verzió-ellenőrzés bekapcsolva</ion-toggle>
        </ion-item>
        <ion-item lines="none">
          <ion-toggle [(ngModel)]="beallitas.utemezett_be">Ütemezett frissítés naponta 00:00-kor és 12:00-kor</ion-toggle>
        </ion-item>
        <ion-note color="medium" class="fr-megjegyzes">
          Ha van újabb, teljes verzió, a rendszer éjfélkor és délben magától telepíti (a kézi indítás mellett is megmarad).
        </ion-note>
        <div class="fr-sor">
          <ion-input label="Registry" labelPlacement="stacked" fill="outline" [(ngModel)]="beallitas.registry"></ion-input>
          <ion-input label="Projekt" labelPlacement="stacked" fill="outline" [(ngModel)]="beallitas.projekt"></ion-input>
          <ion-input label="Képek (vesszővel)" labelPlacement="stacked" fill="outline" [(ngModel)]="beallitas.kepek"></ion-input>
        </div>
        <div class="fr-sor">
          <ion-input label="Registry felhasználó" labelPlacement="stacked" fill="outline"
                     [(ngModel)]="beallitas.felhasznalo"></ion-input>
          <ion-input label="Registry jelszó" labelPlacement="stacked" fill="outline" type="password"
                     [placeholder]="beallitas.jelszo_beallitva ? '•••••• (beállítva)' : ''"
                     [(ngModel)]="beallitas.jelszo"></ion-input>
        </div>
        <div class="fr-sor">
          <ion-input label="Frissítő szolgáltatás címe" labelPlacement="stacked" fill="outline"
                     placeholder="http://frissito:8099" [(ngModel)]="beallitas.frissito_url"></ion-input>
          <ion-input label="Frissítő kulcs" labelPlacement="stacked" fill="outline" type="password"
                     [placeholder]="beallitas.kulcs_beallitva ? '•••••• (beállítva)' : ''"
                     [(ngModel)]="beallitas.frissito_kulcs"></ion-input>
        </div>
        <ion-note color="medium" class="fr-megj">
          A titkokat üresen hagyva a korábbi érték marad meg — a rendszer sosem adja őket vissza.
        </ion-note>
        <ion-button color="primary" [disabled]="mentesFut" (click)="beallitasMentes()">
          <ion-icon slot="start" name="save"></ion-icon>{{ mentesFut ? 'Mentés…' : 'Mentés' }}
        </ion-button>
      </div>
    </ng-container>
  </ion-card-content>
</ion-card>
